<script>
// 取消modal
import i18n from "@/i18n";
import { BUSINESS_DELAY_REASON } from '@/config/common'
export default {
  props: {
    title: {
      type: String,
      default: i18n.global.t('page.cancel-work-order')
    },
    show: {
      type: Boolean,
      default: false
    },
    // 是否显示取消原因
    showCancelReason: {
      type: Boolean,
      default: false
    },
    // 取消原因是否必填
    cancelReasonRequired: {
      type: Boolean,
      default: false
    },
    // 取消原因列表
    cancelReasonList: {
      type: Array,
      default: () => [
        ...BUSINESS_DELAY_REASON
      ]
    },
    // 已选择的取消原因
    selectedCancelReason: {
      type: [String, Number],
      default: null
    },
  },
  data () {
    return {
      showModal: false,
      // 取消原因
      cancelReason: null,
      // 是否需要填写备件金额和备件说明
      needSparePart: false,
      // 备件金额
      sparePartAmount: null,
      // 备件说明
      sparePartRemark: null,
      // 原因说明
      reasonRemark: null,
    }
  },
  methods: {
    cancelReasonChange(value) {
      // 根据value判断是否显示备件金额和备件说明
      if (value == '5') {
        this.needSparePart = true
      } else {
        this.needSparePart = false
      }
    },
    changeCompany(value) {
      this.companyId = value
    },
    ok () {
      this.$emit('ok', {
        cancel_reason: this.cancelReason,
        spare_parts_amount: this.sparePartAmount,
        spare_parts_desc: this.sparePartRemark,
        reason_desc: this.reasonRemark,
      })
    },
    cancel () {
      this.$emit('cancel')
    },
  },
  computed: {
    reasonRemarkRequired() {
      return !this.cancelReasonRequired
    },
    canSubmit() {
      if (this.reasonRemarkRequired && this.reasonRemark) {
        return true
      }
      if (this.cancelReasonRequired && this.cancelReason !== null) {
        if (!this.needSparePart) {
          return true
        }
        if (this.needSparePart && this.sparePartAmount !== null && this.sparePartRemark !== null) {
          return true
        }
      }
      return false
    }
  },
  components: {

  },
  watch: {
    show: {
      immediate: true,
      handler(val) {
        // console.log('showmodal:', val)
        this.showModal = val
      }
    },
    showModal(val) {
      if (!val) {
        this.$emit('cancel')
      }
    },
    selectedCancelReason: {
      immediate: true,
      handler(val) {
        this.cancelReason = val
        if (val == '5') {
          this.needSparePart = true
        } else {
          this.needSparePart = false
        }
      }
    },
  }
}

</script>
<template>

  <b-modal v-model="showModal" id="setCompanyModal" hide-footer :title="title" header-class="p-3 bg-light"
           class="v-modal-custom" centered>

    <div>
      <!--      取消原因-->
      <div class="mb-3" v-if="showCancelReason">
        <div class="mb-3">
          <span>{{ $t('page.repair-request.CancelReason') }}</span>
          <span class="text-danger" v-if="cancelReasonRequired">{{ $t('serviceCompany.not_null') }}</span>
        </div>
        <div class="cancel-reason-wrap">
          <el-select
              v-model="cancelReason"
              placeholder="请选择"
              popper-class="cancel-reason-select"
              @change="(e) => cancelReasonChange(e)"
          >
            <el-option
                v-for="item in cancelReasonList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <!--  备件金额 备件说明    -->
      <div class="mb-3" v-if="needSparePart">
        <b-row>
          <b-col cols="4">
            <div class="mb-3">
              <span>{{ $t('page.parts_amount') }}</span>
              <span class="text-danger">{{ $t('serviceCompany.not_null') }}</span>
            </div>
            <div>
              <b-form-input
                  v-model="sparePartAmount"
                  placeholder="请输入"
              >
              </b-form-input>
            </div>
          </b-col>
          <b-col>
            <div class="mb-3">
              <span>{{ $t('page.parts_explain') }}</span>
              <span class="text-danger">{{ $t('serviceCompany.not_null') }}</span>
            </div>
            <div>
              <b-form-input
                  v-model="sparePartRemark"
                  placeholder="请输入"
              >
              </b-form-input>
            </div>
          </b-col>
        </b-row>
      </div>
      <!--      原因说明-->
      <div class="mb-3">
        <div class="mb-3">
          <span>{{ $t('page.reason_explain') }}</span>
          <span class="text-danger" v-if="reasonRemarkRequired">{{ $t('serviceCompany.not_null') }}</span>
        </div>
        <b-form-textarea
          v-model="reasonRemark"
          rows="3"
        >
        </b-form-textarea>
      </div>
    </div>

    <div class="hstack gap-2 justify-content-end mt-5">
      <b-button type="button" variant="light" @click="cancel">
        {{ $t('base.cancel') }}
      </b-button>
      <b-button type="button" variant="primary" @click="ok" :disabled="!canSubmit">
        {{ $t('base.done') }}
      </b-button>
    </div>

  </b-modal>


</template>
<style lang="scss">
.cancel-reason-select {
  z-index: 3000!important;
}
.cancel-reason-wrap {
  /* #405189 #6559cc #495057 */
  .el-select .el-input.is-focus .el-input__wrapper {
    box-shadow: 0 0 0 1px #405189 inset!important;
    border-radius: 4px!important;
  }
  .el-select .el-input__wrapper.is-focus {
    box-shadow: 0 0 0 1px #405189 inset!important;
    border-radius: 4px!important;
  }
  .select_input .el-input__wrapper, .el-select, .el-input, .is-focus, .el-input__inner {
    color: #212529!important;
  }
}
</style>
